import { render, staticRenderFns } from "./SatellitesPage.vue?vue&type=template&id=642ba3b0&scoped=true"
import script from "./SatellitesPage.vue?vue&type=script&lang=js"
export * from "./SatellitesPage.vue?vue&type=script&lang=js"
import style0 from "./SatellitesPage.vue?vue&type=style&index=0&id=642ba3b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642ba3b0",
  null
  
)

export default component.exports